/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BaseCommentUser } from './baseCommentUser';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskComment { 
    readonly id: number;
    text: string;
    parent?: number | null;
    readonly createdAt: string | null;
    readonly createdBy: BaseCommentUser;
    readonly replies: Array<any>;
    readonly isNew: boolean;
}
export const TaskComment_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskComment_text_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskComment_parent_Validators: ValidatorFn[] =
    [ ];

export const TaskComment_createdAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskComment_createdBy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskComment_replies_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskComment_isNew_Validators: ValidatorFn[] =
    [  Validators.required, ];


